import { Api } from '../../axios-config/AxiosConfig';
import { ApiException } from '../ApiException';

export interface IGerar2FARequest {
  usuario: string;
  tenantId: string;
  callId?: string;
  reason?: string;
}

export interface IGerar2FAResponse {
  token: string;
}

const gerar2FA = async (params: IGerar2FARequest): Promise<IGerar2FAResponse | ApiException> => {
  try {
    const response = await Api.post('/AuthGvdasa', params);
    return response.data as IGerar2FAResponse;
  } catch (error: any) {
    console.error(error);
    const message = error?.response?.data?.error || error.message || 'Erro ao gerar código 2FA.';
    return new ApiException(message);
  }
};

export const AuthGvdasaService = {
  gerar2FA,
};
